import React, { FunctionComponent, memo } from "react";
import { Box } from "@mui/material";
import { EsgAnomalyWarning } from "assets";

import { AlertBannerProps } from "./types";
import { DEFAULT_BG, VARIANT_STYLES } from "./styles";

export const AlertBanner: FunctionComponent<AlertBannerProps> = memo(
  ({ variant = "warning", title, message, bgColor, action, footer, sx }) => {
    const bg = bgColor ?? DEFAULT_BG[variant];
    const { paddingInlineStart, iconColor, titleColor, messageTag: Tag } =
      VARIANT_STYLES[variant];

    return (
      <Box
        sx={{
          bgcolor: bg,
          borderRadius: "4px",
          padding: action ? "0px 0px 24px 16px" : "24px 0px 24px 16px",
          width: "584px",
          ...sx,
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            {action}
          </Box>
          <Box
            sx={{
              display: "flex",
              gap: "10px",
              paddingRight: "24px",
              marginBottom: 0,
              marginLeft: "10px",
              "& > h3": { margin: 0, fontWeight: "600", fontSize: "14px", color: titleColor },
              "& > svg": { color: iconColor, transform: VARIANT_STYLES[variant].iconRotate ?? "none" },
            }}
          >
            <EsgAnomalyWarning />
            <h3>{title}</h3>
          </Box>
        </Box>
        <ul
          style={{
            fontSize: "12px",
            fontWeight: "500",
            paddingInlineStart,
            paddingRight: "24px",
            marginBottom: 0,
          }}
        >
          <Tag style={{ textWrap: "wrap", marginBottom: footer ? "8px" : 0 }}>
            {message}
          </Tag>
          {footer && <Tag style={{ textWrap: "wrap" }}>{footer}</Tag>}
        </ul>
      </Box>
    );
  },
);
